import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Banknote } from 'lucide-react';
import { fmtCurrency, getCurrencySymbol } from '../../lib/localeUtils';

const QUICK_AMOUNTS = [50, 100, 200, 500];

/** Cash tendered + change-due block — only meaningful for cash payments. */
export const POSCashTender = ({ cashReceived, setCashReceived, total }) => {
  const tendered = parseFloat(cashReceived);
  const symbol = getCurrencySymbol();
  return (
    <div className="space-y-2 rounded-lg border bg-emerald-50/40 dark:bg-emerald-950/20 p-3" data-testid="cash-tendered-block">
      <div className="flex items-center justify-between">
        <Label className="text-xs flex items-center gap-1.5">
          <Banknote className="h-3.5 w-3.5 text-emerald-600" />
          Cash tendered
        </Label>
        {cashReceived && tendered >= total && (
          <span className="text-xs font-semibold text-emerald-700 dark:text-emerald-400" data-testid="change-due">
            Change: {fmtCurrency(tendered - total)}
          </span>
        )}
      </div>
      <div className="flex flex-wrap gap-1.5">
        {QUICK_AMOUNTS.map((amt) => (
          <button
            key={amt}
            type="button"
            onClick={() => setCashReceived(String(amt))}
            className={[
              'px-3 py-1.5 rounded-md border text-xs font-semibold transition-colors',
              tendered === amt
                ? 'bg-emerald-600 text-white border-emerald-600'
                : 'bg-white dark:bg-card border-emerald-200 hover:border-emerald-400 hover:bg-emerald-50',
            ].join(' ')}
            data-testid={`tender-chip-${amt}`}
          >
            {symbol}{amt}
          </button>
        ))}
        <button
          type="button"
          onClick={() => setCashReceived(String(total.toFixed(2)))}
          className={[
            'px-3 py-1.5 rounded-md border text-xs font-bold transition-colors',
            Math.abs(tendered - total) < 0.005
              ? 'bg-emerald-600 text-white border-emerald-600'
              : 'bg-emerald-100 text-emerald-800 border-emerald-300 hover:bg-emerald-200',
          ].join(' ')}
          data-testid="tender-chip-exact"
        >
          Exact
        </button>
      </div>
      <Input
        type="number"
        inputMode="decimal"
        step="0.01"
        min={0}
        placeholder="Custom amount"
        value={cashReceived}
        onChange={(e) => setCashReceived(e.target.value)}
        className="h-9 text-sm tabular-nums"
        data-testid="cash-tendered-input"
      />
      {cashReceived && tendered > 0 && tendered < total && (
        <p className="text-[11px] text-amber-700 dark:text-amber-500" data-testid="cash-shortfall">
          Short by {fmtCurrency(total - tendered)} — accept partial or top up.
        </p>
      )}
    </div>
  );
};
